import { useAtomValue } from 'jotai'
import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'
import useOwnedCarbonTokens from 'src/common/apollo/hooks/useOwnedCarbonTokens'
import useBalance from 'src/common/contracts/hooks/token/useBalance'
import useCarbon from 'src/common/queries/useCarbon'
import useVicc from 'src/common/queries/useVicc'
import useConfig from 'src/config/hooks/useConfig'
import { viccCountAtom } from '../../bundle-store'
import useCarbonBundleInfo from 'src/common/contracts/hooks/carbon-bundles/useCarbonBundleInfo'

const useCarbonBundleWithdrawState = () => {
  const {
    carbonBundleInfo: { withdrawalFee },
  } = useCarbonBundleInfo()
  const { smartAccountInfo } = useSmartAccount()
  const { contractsAddresses } = useConfig()

  const viccCount = useAtomValue(viccCountAtom)
  const depositFeeNum = Number(withdrawalFee?.toString() || '0') / 10000
  const burnValue =
    depositFeeNum > 0 ? viccCount - viccCount * depositFeeNum : viccCount
  const { vicc, isLoading: viccLoading } = useVicc()

  const { ownedCarbonTokens: carbonInBundle, loading: ownedCarbonLoading } =
    useOwnedCarbonTokens(contractsAddresses.carbonBundleAddress)

  const { carbon, isLoading: carbonLoading } = useCarbon()

  const { balance: userBundleBalance, isLoading: userBalanceLoading } =
    useBalance({
      token: carbon,
      owner: smartAccountInfo?.address,
    })

  const maxValue = Math.floor(Math.min(userBundleBalance?.toNumber() || 0, 100))

  const loading =
    carbonLoading || ownedCarbonLoading || userBalanceLoading || viccLoading

  return {
    vicc,
    maxValue,
    carbonInBundle,
    burnValue,
    loading,
  }
}

export default useCarbonBundleWithdrawState
